import { CSS_RESET } from "src/apps/config/css-reset";
import styled, { createGlobalStyle } from "styled-components";
import { ReactNode, useEffect } from "react";
import { MEDIA_MOBILE_BREAKPOINT } from "../../config/constants";
import { useSetTheme } from "src/apps/providers/ThemeStore";
import { useGetCustomerCustomization } from "src/apps/hooks/useGetCustomization";
import { LoadingScreen } from "../loading/LoadingScreen";
import { colors } from "@permisso/permisso-components";

interface BaseScreenProps {
  header?: ReactNode;
  children: ReactNode;
  // This should not be like this as I think we shouldn't have different bgColors according to the screen size
  backgroundColor?: string;
  mobileBackgroundColor?: string;

  screenPadding?: string;
  mobileScreenPadding?: string;
}

export const BaseScreen = ({
  header,
  children,
  backgroundColor = colors.grey300,
  mobileBackgroundColor = colors.grey0,
  screenPadding = "0",
  mobileScreenPadding = "0",
}: BaseScreenProps) => {
  const setTheme = useSetTheme();
  const { data: customization, isLoading } = useGetCustomerCustomization();

  useEffect(() => {
    if (customization) {
      setTheme(customization);
    }
  }, [customization, setTheme]);

  if (isLoading) return <LoadingScreen />;

  return (
    <Layout
      $backgroundColor={backgroundColor}
      $mobileBackgroundColor={mobileBackgroundColor}
      $screenPadding={screenPadding}
      $mobileScreenPadding={mobileScreenPadding}
    >
      {header ? header : null}
      <GlobalStyle />
      {children}
    </Layout>
  );
};
export const GlobalStyle = createGlobalStyle`
  ${CSS_RESET}
`;

const Layout = styled.div<{
  $backgroundColor: string;
  $mobileBackgroundColor: string;
  $screenPadding: string;
  $mobileScreenPadding: string;
}>`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  padding: ${({ $screenPadding }) => $screenPadding}rem;

  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    background-color: ${({ $mobileBackgroundColor }) => $mobileBackgroundColor};
    padding: ${({ $mobileScreenPadding }) => $mobileScreenPadding};
  }
`;
